module.exports = __webpack_public_path__ + "img/arrow.6bb1e162.svg";